import './header.css';
import React from 'react';
import {header}  from '../../modules/data'; 
import { getbyID } from '../../modules/datafunction';
import { useState } from 'react';
import { InstaSVG } from '../../modules/svgdata';
const Header = () => {
  const hdata=getbyID({item:0},header)
  const [headerData, setHeaderData] = useState(hdata);
  console.log(headerData['title']);
  return (
    <header>
            <div className="header">
              <a href="/" >
                  <img  src={headerData['imglogo']}  alt="LOGO" />
                  </a>      
            <ul className="nav-list">
               {headerData['li'].map((item,index)=>( <li key={index}> 
                <a href={headerData['a'][index]}> {item}</a></li>  ))}
            </ul>
            <ul className='nav-list-social'>
                  { headerData['i'].map((item,index)=>( <li key={index}> 
                  <a href={headerData['href'][index]}> {item} </a></li>))
                  }
            </ul>
       </div>
    </header>
  );
}
export default Header;